import { useEffect, useRef, useState } from "react"
import dayjs, { Dayjs } from "dayjs"

import { ReactComponent as IconCalendar } from "assets/svg/icon-calendar.svg"
import { ReactComponent as IconTableCross } from "assets/svg/icon-table-cross.svg"

import { useOutsideClick } from "utils/useOutsideClick"
import useUrlQueryParams from "hooks/useUrlQueryParams"

import { SingleDatePicker } from "./SingleDatePicker"

import styles from "./index.module.scss"

interface Props {
  name?: string
}

export const TableDatePicker = ({ name }: Props) => {
  const [isActive, setActive] = useState(false)
  const [value, setValue] = useState<Dayjs | null>(null)
  const { urlQueryParams, setUrlQueryParams } = useUrlQueryParams()
  const datePickerRef = useRef<HTMLDivElement>(null)

  useOutsideClick(datePickerRef, () => setActive(false))

  const onClear = () => {
    setValue(null)
    if (name) {
      setUrlQueryParams({ [name]: null })
    }
    setActive(false)
  }

  const onDateSelect = (date: Dayjs | null) => {
    const formattedDate = date ? date.format("YYYY-MM-DD") : null

    if (name) {
      setUrlQueryParams({
        [name]: formattedDate,
      })
    }

    setValue(date)
    setActive(false)
  }

  useEffect(() => {
    if (name && urlQueryParams[name]) {
      setValue(dayjs(urlQueryParams[name]))
    } else if (urlQueryParams && name && !Object.hasOwn(urlQueryParams, name)) {
      setValue(null)
      setActive(false)
    }
  }, [urlQueryParams, name])

  return (
    <div className={styles.tableDateWrapper} onClick={() => {}}>
      {isActive ? (
        <div className={styles.inputWrapper} ref={datePickerRef}>
          <SingleDatePicker value={value} onSelect={onDateSelect} />
        </div>
      ) : value ? (
        <div className={styles.valueWrapper}>
          <span
            className={styles.value}
            onClick={e => {
              e.stopPropagation()
              setActive(true)
            }}
          >
            {value.format("YYYY-MM-DD")}
          </span>
          <span className={styles.icon} onClick={onClear}>
            <IconTableCross />
          </span>
        </div>
      ) : (
        <span
          className={styles.icon}
          onClick={e => {
            e.stopPropagation()
            setActive(true)
          }}
        >
          <IconCalendar />
        </span>
      )}
    </div>
  )
}
